<script lang="ts">
	import { cn } from '$lib/utils/shadcn'

	export let href: string
	export let itemprop: string
	let className = ''
	export { className as class }
</script>

<a class={cn('hover:text-foreground transition-colors', className)} {href} {itemprop}>
	<slot />
</a>
